import {ReactNode, useEffect, useState} from 'react';
import useTypedDispatch from '../../../../../../common/useTypedDispatch';
import useTypedSelector from '../../../../../../common/useTypedSelector';
import {Loading} from '../../../../../../design-system/atoms/Loading/Loading';
import {ImageViewerData} from '../../../../../../graphql/generated/types';
import {useViewerInfoQuery} from '../../../../../../wrapper/viewerWrapper';
import {setDownloadData, setTotalPage} from '../state/imageViewerSlice';

export function PreviewImageViewerFetcherHeadless({
  seriesId,
  productId,
  children,
}: {
  seriesId: number;
  productId: number;
  children: ReactNode;
}) {
  const [isLoaded, setIsLoaded] = useState<boolean>();

  const {downloadData} = useTypedSelector(state => {
    return {
      downloadData: state.imageViewer.viewData[productId].downloadData,
    };
  });
  const {data} = useViewerInfoQuery({seriesId, productId});
  const viewerData = data?.viewerData as ImageViewerData;
  const downloadDataInViewerInfo = viewerData?.imageDownloadData;

  const dispatch = useTypedDispatch();

  useEffect(() => {
    if (!downloadData) {
      setIsLoaded(false);
      dispatch(
        setDownloadData({productId, downloadData: downloadDataInViewerInfo})
      );
    }
  }, [downloadDataInViewerInfo, dispatch, productId, downloadData]);

  useEffect(() => {
    if (!downloadData || isLoaded) {
      return;
    }
    dispatch(
      setTotalPage({
        productId,
        totalPage: downloadData.files.length || 1,
      })
    );

    setIsLoaded(true);
  }, [dispatch, downloadData, isLoaded, productId]);

  return (
    <>
      {!isLoaded && (
        <div className="flex-center-full">
          <Loading />
        </div>
      )}
      {isLoaded && children}
    </>
  );
}
